module.exports = __webpack_public_path__ + "static/media/page15_mum_kids.13367d79.png";